/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Locked_LabelInputs */



/**
* | output |
* | --- |
* | "Locked" |
*
* @param {Explorer_Info_Locked_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_locked_label = /** @type {((inputs?: Explorer_Info_Locked_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Locked_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verrouille")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesperrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bloccato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заблокировано")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bloqueado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロックされています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trancado")
	return /** @type {LocalizedString} */ ("Locked")
});